<template>
  <span v-if="chips.length" class="e-chips-extensao-etapa">
    <v-tooltip bottom v-for="chip in chips" :key="chip.tipo">
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          small
          class="text-none ml-2"
          :color="chip.cor"
          text-color="white"
        >
          {{ chip.texto }}
        </v-chip>
      </template>
      <span>{{ chip.explicacao }}</span>
    </v-tooltip>
  </span>
</template>

<script>
import { dateFormatParam } from "@/plugins/filters";

export default {
  name: "EChipsExtensaoEtapa",

  props: {
    etapa: {
      type: Object,
      default: null,
    },
    // A antecipação do início só vale para aulas, então em outros contextos o chip é omitido.
    contexto: {
      type: String,
      default: "aulas",
    },
  },

  computed: {
    hoje() {
      const agora = new Date();
      const mes = `${agora.getMonth() + 1}`.padStart(2, "0");
      const dia = `${agora.getDate()}`.padStart(2, "0");
      return `${agora.getFullYear()}-${mes}-${dia}`;
    },

    chips() {
      const chips = [];
      const antecipacao = this.etapa?.periodo_extensao_inicial;
      const prorrogacao = this.etapa?.periodo_extensao;

      if (antecipacao && this.contexto === "aulas") {
        const vigente = antecipacao <= this.hoje;
        chips.push({
          tipo: "antecipacao",
          texto: `${vigente ? "Antecipado desde" : "Antecipado a partir de"}: ${dateFormatParam(
            antecipacao,
            "d/m/y"
          )}`,
          cor: vigente ? "green darken-3" : "primary",
          explicacao: "Liberação antecipada do início — vale apenas para lançamento de aulas",
        });
      }

      if (prorrogacao) {
        const vigente = prorrogacao >= this.hoje;
        chips.push({
          tipo: "prorrogacao",
          texto: `Estendido até: ${dateFormatParam(prorrogacao, "d/m/y")}`,
          cor: vigente ? "green darken-3" : "red",
          explicacao: "Prorrogação do fim — vale para aulas, notas e planos",
        });
      }

      return chips;
    },
  },
};
</script>
